import type { RemoteZone } from '#/api/types/ApiRemoteOptions';
import type { I18nFn } from '#/i18n/types/I18nFn';
import type { ListingType } from '#/types/ListingType';

function REMOTE_ZONE_JOB(i18n: I18nFn) {
  return {
    // TRANSLATORS: remote work zone
    WORLD: i18n('Employee can be anywhere in the world'),
    // TRANSLATORS: remote work zone
    COUNTRY: i18n('Employee must be in a certain country'),
    // TRANSLATORS: remote work zone
    STATE: i18n('Employee must be in a certain U.S. state'),
    // TRANSLATORS: remote work zone
    CITY: i18n('Employee must be in a certain city or town'),
  };
}

function REMOTE_ZONE_INTERNSHIP(i18n: I18nFn) {
  return {
    // TRANSLATORS: remote work zone
    WORLD: i18n('Intern can be anywhere in the world'),
    // TRANSLATORS: remote work zone
    COUNTRY: i18n('Intern must be in a certain country'),
    // TRANSLATORS: remote work zone
    STATE: i18n('Intern must be in a certain U.S. state'),
    // TRANSLATORS: remote work zone
    CITY: i18n('Intern must be in a certain city or town'),
  };
}

function REMOTE_ZONE_VOLOP(i18n: I18nFn) {
  return {
    // TRANSLATORS: remote work zone
    WORLD: i18n('Volunteer can be anywhere in the world'),
    // TRANSLATORS: remote work zone
    COUNTRY: i18n('Volunteer must be in a certain country'),
    // TRANSLATORS: remote work zone
    STATE: i18n('Volunteer must be in a certain U.S. state'),
    // TRANSLATORS: remote work zone
    CITY: i18n('Volunteer must be in a certain city or town'),
  };
}

export function getRemoteZone({
  i18n,
  listingType,
  zone,
}: {
  i18n: I18nFn;
  listingType: Omit<ListingType, 'EVENT'> | undefined;
  zone: RemoteZone;
}) {
  if (listingType === 'VOLOP') return REMOTE_ZONE_VOLOP(i18n)[zone];

  if (listingType === 'INTERNSHIP') return REMOTE_ZONE_INTERNSHIP(i18n)[zone];

  return REMOTE_ZONE_JOB(i18n)[zone];
}
